import { Observable } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root"
})
export class ServiceWorkOrderService {
  private baseRoute: string;
  private inventoryRoute: string;
  private employeesRoute: string;
  private customersRoute: string;

  constructor(private httpClient: HttpClient) {
    this.baseRoute = environment.serviceworkorderAPIRoot;
    this.inventoryRoute = environment.inventoryAPIRoot;
    this.employeesRoute = environment.accountAPIRoot;
    this.customersRoute = environment.customerAPIRoot;
  }

  getAllServiceWorkOrder<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/getall`);
  }

  //ACTUAL DATA
  //LIBRARIES
  getAllCustomers<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.customersRoute}/customer/getall`);
  }

  getAllEmployees<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.employeesRoute}/getallemployees`);
  }

  getAllServices<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.inventoryRoute}/service/getall`);
  }

  searchServices<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.inventoryRoute}/service/search`);
  }

  //WORK ORDER
  getWorkOrderId<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/main/getid`);
  }

  getWorkOrders<T>(locationId: number): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/main/getall?locationId=${locationId}`);
  }

  getWorkOrder<T>(workOrderId: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/main/get/${workOrderId}`);
  }

  saveWorkOrder<T>(payload: any): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}/main/save`, payload);
  }

  deleteWorkOrder<T>(workOrderId: string): Observable<T> {
    return this.httpClient.delete<T>(`${this.baseRoute}/main/delete/${workOrderId}`);
  }

  statusUpdate<T>(workOrderId: string, status: number, userId: number): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}/main/status/update/${workOrderId}/${status}/${userId}`, {});
  }

  verifyWorkOrderClient<T>(workOrderId: string, emailAddress: string): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}/main/verifyworkordercustomer/${workOrderId}/${emailAddress}`, {});
  }

  checkEmployeeScheduleConflict<T>(startDate: string, endDate: string, employeeId: number, id: number) {
    return this.httpClient.get<T>(`${this.baseRoute}/employee/checkschedule/${startDate}/${endDate}/${employeeId}/${id}`);
  }

  saveInvoiceWorkOrder<T>(workOrderId: string, invoiceNumber: string): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}/main/saveinvoiceworkorder/${workOrderId}/${invoiceNumber}`, {});
  }

  getInvoiceWorkOrder<T>(workOrderId: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/main/getinvoiceworkorder/${workOrderId}`);
  }

  getWorkOrderCustomerAndEmployeeInfo<T>(workOrderId: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/main/getworkordercustomerandemployeeinfo/${workOrderId}`);
  }

  getWorkOrderByInvoice<T>(invoiceNumber: string): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/main/getworkorderbyinvoice/${invoiceNumber}`);
  }

  getSettingsWorkOrder<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/settings/getsettingsworkorder`);
  }

  upsertSettingsWorkOrder<T>(settings:any): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}/settings/upsertsettingsworkorder`, settings);
  }

  getCustomerSigByWorkOrderId<T>(workOrderId: string): Observable<T>{
    return this.httpClient.get<T>(`${this.baseRoute}/main/getcustomersigbyworkorderid/${workOrderId}`);
  }

  getEmailStatusSendingConfig<T>(): Observable<T> {
    return this.httpClient.get<T>(`${this.baseRoute}/settings/getemailstatussendingconfig`);
  }

  upsertEmailStatusSendingConfig<T>(settings:any): Observable<T> {
    return this.httpClient.post<T>(`${this.baseRoute}/settings/upsertemailstatussendingconfig`, settings);
  }
}

